import { withPaginationParams, isMongoId } from '../../helpers';
import { z } from 'zod';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from '../../../utils';
import { TransactionOperation } from 'further-types/lp/transaction';

export const currencyRateOverridesSchema = z.record(
  z.nativeEnum(CurrencyCode),
  z.object({
    overrideRate: z.number().optional(),
    overrideSource: z.string().optional(),
  }),
);

export const CreateUnrealisedFXGainOrLossInput = z.object({
  transactions: z.array(
    z.object({
      sourceTransactionId: z.string().refine(isMongoId(), {
        message: 'Please provide a valid source transaction ID',
      }),
      transactions: z.array(
        z.object({
          transactionTypeId: z.string().refine(isMongoId(), {
            message: 'Please provide a valid transaction type ID',
          }),
          operationType: z.nativeEnum(TransactionOperation),
        }),
      ),
    }),
  ),
  currencyRateOverrides: currencyRateOverridesSchema.optional(),
  viewDate: z.instanceof(CalendarDay),
});

export const GetUnrealisedFXGainsInput = withPaginationParams(
  z.object({
    viewDate: z.instanceof(CalendarDay),
    currencyRateOverrides: currencyRateOverridesSchema.optional(),
  }),
  ['transactionDate'],
);
